import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActionCardComponent } from '../../../../../shared/components/action-card/action-card.component';

export type FormatoContagem = 'imprimir' | 'exportar' | 'digitar';

export interface EscolherFormatoContagemData {
  totalProdutos: number;
}

@Component({
  selector: 'app-escolher-formato-contagem',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ActionCardComponent,
  ],
  templateUrl: './escolher-formato-contagem.component.html',
  styleUrl: './escolher-formato-contagem.component.css',
})
export class EscolherFormatoContagemComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EscolherFormatoContagemData,
    private dialogRef: MatDialogRef<EscolherFormatoContagemComponent, FormatoContagem>,
  ) {}

  public escolher(opcao: FormatoContagem): void {
    this.dialogRef.close(opcao);
  }
}
